// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import Button, { type ButtonProps } from '@mui/material/Button'

/** D-UI-3 — the kit's button (pages import the kit, never @mui directly). Theme defaults: small, no elevation. */
export default function AppButton(props: ButtonProps) {
  return <Button {...props} />
}
